window.addEventListener('load', function () {
    const tabs = document.querySelector<HTMLElement>('.product-tabs');
    const description = tabs?.querySelector<HTMLElement>('.woocommerce-product-details__short-description');
    const toggleButton = tabs?.querySelector<HTMLElement>('.woocommerce-product-details__short-description-toggle');

    if (!description || !toggleButton) {
        return;
    }

    toggleButton?.addEventListener('click', function () {
        description.classList.toggle('expanded');
        toggleButton.textContent = description?.classList.contains('expanded') ? 'Lees minder' : 'Lees meer';
    });
});